// components/Logo.jsx
import logo from "../../assets/corevia_logo_150.svg"

const Logo = () => {
  return (
    <div className="logo">
      <img src={logo} alt="Corevia" className="logo-image" />

      <div className="logo-text-wrap">
        <div className="logo-title">BRSR Compass</div>
        <div className="logo-tagline">by Corovia Systems</div>
      </div>
    </div>
  );
};
export default Logo;
